import { HdataLogo } from '@sailadv/hdata-ui';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import { AppRoutes } from '@/shared/constants/app-routes.constant';

import { UserMenu } from '../user-menu';

const TopBarComponent = () => (
	<header className="flex items-center justify-between px-6 py-4 md:px-9 md:py-6">
		<Link to={AppRoutes.Home} className="flex items-center gap-1.5 text-foreground">
			<HdataLogo className="size-7 md:size-8" />
			<span className="font-heading text-xl font-semibold tracking-tight md:text-2xl">D.gree</span>
		</Link>
		<UserMenu />
	</header>
);

export default memo(TopBarComponent);
